import { message, Select } from "antd"
import React, { useEffect, useState } from "react"
import DropdownService from "src/services/DropdownService"
import WarehouseService from "src/services/WarehouseService"

const SelectProvider = ({
  value,
  onChange,
  disabled,
  style = { height: "36px" },
}) => {
  const [providers, setProviders] = useState([])

  useEffect(() => {
    fetchProvider()
  }, [])

  const fetchProvider = async () => {
    try {
      const response = await DropdownService.getListAllSupplier()
      setProviders(response?.success || [])
    } catch (error) {
      console.error("Lỗi khi lấy danh sách nhà cung cấp", error)
      message.error("Không thể lấy danh sách nhà cung cấp")
    }
  }

  return (
    <Select
      placeholder="Chọn nhà cung cấp"
      title="Chọn nhà cung cấp"
      allowClear
      showSearch
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={style}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
      }
    >
      {providers.map(provider => (
        <Select.Option key={provider.ID} value={provider.ID}>
          {provider.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectProvider
